'use client'

import { useState } from 'react'
import { FileText } from 'lucide-react'
import { formatDateLong } from '@/utils/util'
import SidePanel, { panelFocusRing } from './SidePanel'
import CenterModal from './CenterModal'

type TermsType = 'delivery' | 'payment' | 'service'

const TABS: { id: TermsType, label: string, title: string }[] = [
  { id: 'delivery', label: 'Хүргэлт', title: 'Хүргэлтийн нөхцөл' },
  { id: 'payment', label: 'Төлбөр', title: 'Төлбөрийн нөхцөл' },
  { id: 'service', label: 'Үйлчилгээ', title: 'Үйлчилгээний нөхцөл' },
]

export default function TermsDrawer({ isOpen, onClose, type, terms, vendor, modal = false }: { isOpen: boolean, onClose: () => void, type: TermsType | null, terms: { delivery?: string, payment?: string, service?: string }, vendor?: any, modal?: boolean }) {
  const [activeType, setActiveType] = useState<TermsType>(type ?? 'delivery')
  const [prevType, setPrevType] = useState<TermsType | null>(type)

  if (type && type !== prevType) {
    setPrevType(type)
    setActiveType(type)
  }

  const active = TABS.find(t => t.id === activeType) ?? TABS[0]
  const rawContent = terms[activeType]
  const hasContent = !!rawContent && rawContent.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim().length > 0
  const Shell = modal ? CenterModal : SidePanel

  return (
    <Shell
      open={isOpen}
      onClose={onClose}
      title={active.title}
      subtitle={
        <div role="tablist" className="mt-4 flex items-center gap-6 border-b border-border">
          {TABS.map(t => (
            <button key={t.id} type="button" role="tab" aria-selected={activeType === t.id} onClick={() => setActiveType(t.id)} className={`-mb-px py-3 border-b text-[13px] transition-colors duration-150 ${activeType === t.id ? 'border-foreground text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'} ${panelFocusRing}`}>
              {t.label}
            </button>
          ))}
        </div>
      }
      footer={
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs text-muted-foreground">{vendor?.createdAt ? `Дэлгүүр нээгдсэн: ${formatDateLong(new Date(vendor.createdAt))}` : ''}</span>
          <button type="button" onClick={onClose} className={`h-11 px-8 bg-foreground text-background text-[13px] tracking-wide transition-opacity duration-150 hover:opacity-85 ${panelFocusRing}`}>Ойлголоо</button>
        </div>
      }
    >
      {hasContent ? (
        <div className="prose prose-sm max-w-none text-sm leading-relaxed text-foreground" dangerouslySetInnerHTML={{ __html: rawContent! }} />
      ) : (
        <div className="flex flex-col items-center py-16 text-center">
          <FileText aria-hidden className="size-10 text-muted-foreground" strokeWidth={1} />
          <p className="mt-4 text-sm text-muted-foreground">Мэдээлэл олдсонгүй</p>
        </div>
      )}
    </Shell>
  )
}
